import React from 'react';
import { useTranslation } from 'react-i18next';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { LinkButton } from './link-button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getActionIconButtonSize } from './inline-base-styles';

export interface ReportButtonProps {
  text?: string;
  startIcon?: React.ReactNode;
  withoutText?: boolean;
  disabled?: boolean;
  canEdit?: boolean;
  targetId: string;
  size?: 'large' | 'medium' | 'small';
  target?: '_blank' | '_self';
  style?: React.CSSProperties;
}

export const ReportButtonWithText: React.FC<
  Omit<ReportButtonProps, 'withoutText'>
> = ({ text, targetId, target, style, ...rest }) => {
  const { t } = useTranslation(['translation', 'admin']);

  return (
    <LinkButton
      to={`/incidents/${targetId}`}
      variant={'contained'}
      color={'primary'}
      size={'small'}
      target={target ? target : '_self'}
      style={style}
      startIcon={
        <FontAwesomeIcon icon={faFileAlt} size="sm" aria-hidden="true" />
      }
    >
      {String(t(`incidents.report.link`))}
    </LinkButton>
  );
};

export const ReportButtonWithoutText: React.FC<
  Omit<ReportButtonProps, 'text' | 'withoutText'>
> = ({ targetId, target, size = 'small', style, ...rest }) => {
  const dimension = getActionIconButtonSize(size);

  return (
    <LinkButton
      to={`/incidents/${targetId}`}
      variant={'contained'}
      color={'primary'}
      size={size}
      target={target ? target : '_self'}
      {...rest}
      style={{
        ...style,
        width: dimension,
        minWidth: dimension,
        maxWidth: dimension,
        height: dimension,
        minHeight: dimension,
        maxHeight: dimension,
        marginBottom: '0',
        padding: '0',
      }}
    >
      <FontAwesomeIcon icon={faFileAlt} size="sm" aria-hidden="true" />
    </LinkButton>
  );
};
